module.exports = __webpack_public_path__ + "img/CM-MS-24-Mitsubishi-Modern.36bf8c0c.jpg";